<script>
	import { DropdownItem, Table } from "@sveltestrap/sveltestrap";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import { convert } from "../../../services/helpers";
	import client from "../../../services/client";
	import { loading, totalPages, initPage } from "../../../store/store";
	import { onMount, onDestroy } from "svelte";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";

	let groupId = window.location.pathname.split(
		"/master-data/group/details/"
	)[1];

	let dataMember = [];
	let load;
	loading.subscribe((value) => {
		load = value;
	});
	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(`/v0/Group/Members`, {
				method: "POST",
				version: "Tasking",
				data: {
					groupId,
					page: $initPage,
				},
			});

			dataMember = res.data.data.members;
			totalPages.set(res.data.data.totalPages);
			loading.set(false);
		} catch (error) {
			loading.set(false);
			console.log(error);
		}
	});

	const trigerLoad = async () => {
		try {
			loading.set(true);
			const res = await client(`/v0/Group/Members`, {
				method: "POST",
				version: "Tasking",
				data: {
					groupId: groupId,
					page: $initPage,
				},
			});
			dataMember = res.data.data.members;
			loading.set(false);
		} catch (error) {
			loading.set(false);
		}
	};

	const handleRemove = async (id) => {
		try {
			const res = await client(`/v0/Group/RemoveGrouping`, {
				method: "POST",
				version: "Tasking",
				data: {
					group: groupId,
					user: id,
				},
			});
			trigerLoad();
		} catch (error) {
			loading.set(false);
			console.log(error);
		}
	};

	onDestroy(() => {
		initPage.set(1);
	});
</script>

{#if load}
	<LoaderContainer />
{/if}
<h5>Members</h5>
<div class="tbodyDiv">
	<Table responsive hover>
		<thead class="sticky-top">
			<tr>
				<th> Name </th>
				<th> Mobile No. </th>
				<th> Joined At </th>
				<th> Actions </th>
			</tr>
		</thead>
		<tbody>
			{#each dataMember as { userId, fullName, countryCode, mobileNumber, joinedAt }}
				<tr>
					<td>
						<p>
							<span class="link link-text"> {fullName} </span>
						</p>
					</td>
					<td>
						<span> +{countryCode}{mobileNumber}</span>
					</td>
					<td>
						<span> {convert(joinedAt)} </span>
					</td>
					<td>
						<TableDropdown>
							<DropdownItem on:click={() => handleRemove(userId)}
								>Remove</DropdownItem
							>
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
</div>
<Pagination totalRecord={dataMember.length} />
{#if dataMember.length === 0 && !$loading}
	<p class="text-center">No data to display</p>
{/if}

<style>
	.tbodyDiv {
		max-height: clamp(38em, 76vh, 550px);
		overflow: hidden;
		margin-bottom: 15px;
		overflow: auto;
	}
</style>
